import axios from '../jslib/http'
import {request} from '../jslib/request'
import qs from 'qs'
const BASE_REQUEST = '/tms/ship'



let PromiseCache_getAllShip = null
export function getAllShip() {
    if (PromiseCache_getAllShip) {
        return PromiseCache_getAllShip
    }
    const tmp = request({
        url:`${BASE_REQUEST}/getAllShip`
    })
    tmp.then(()=>{
        PromiseCache_getAllShip = tmp
    })
    return tmp
}
export function getAllShipNameAndWeight() {
  return request({
      url:`${BASE_REQUEST}/getAllShipNameAndWeight`
  })
}

export function updateWeightByName(shipName,shipWeight) {
  const url = `${BASE_REQUEST}/updateWeightByName`
    var data = {
      shipName,
      shipWeight
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}


export function getShipList(pageNo,pageSize,qName,qShiptype,qmarket) {
    const url = `${BASE_REQUEST}/getShipList`
    var data = {
        pageNo:pageNo,
        pageSize:pageSize,
        qName:qName,
        qShiptype:qShiptype,
        qmarket:qmarket,
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}
export function updateShip(
    obj
) {
    const url = `${BASE_REQUEST}/updateShip`
    var data = obj
    return axios
        .post(url, qs.stringify(data))
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}
export function delShip(
    id
) {
    const url = `${BASE_REQUEST}/delShip`
    var data = {
        id:id
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}
export function saveShip(
    obj
) {
    const url = `${BASE_REQUEST}/saveShip`
    var data = obj
    return axios
        .post(url, qs.stringify(data))
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}


